import { render, staticRenderFns } from "./ModelBindingRow.vue?vue&type=template&id=4af69f49&scoped=true"
import script from "./ModelBindingRow.vue?vue&type=script&lang=js"
export * from "./ModelBindingRow.vue?vue&type=script&lang=js"
import style0 from "./ModelBindingRow.vue?vue&type=style&index=0&id=4af69f49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af69f49",
  null
  
)

export default component.exports